
export class ModalsManager {

    openedModals = [];

    updateDialogsStack() {
        let zIndex = 2100;
        const count = this.openedModals.length;
        const hasMinimizeButton = this.openedModals.filter(m => m.minimizeButton).length > 0;

        for (let modal of this.openedModals) {
            zIndex += 10;

            if (modal.constructor.name === 'Dialog') {
                modal.$main
                    .css({zIndex})
                    .toggle(!modal.minimized);

                modal.setBsModalOptions({
                    backdrop: hasMinimizeButton && count > 1 ? 'static' : modal.options?.backdrop,
                });

                if (modal.$backdrop) {
                    modal.$backdrop
                        .css({zIndex: zIndex - 1})
                        .toggle(!modal.minimized);
                }
            } else {
                modal.style.setProperty('--z-index', zIndex);
                modal.opened = !modal.minimized;
            }
        }
    }

    isModalOnTop(modal) {
        return this.openedModals[this.openedModals.length - 1] === modal;
    }

    moveModalToTop(modal) {
        const index = this.openedModals.indexOf(modal);
        if (index > -1) {
            this.openedModals.splice(index, 1);
            this.openedModals.push(modal);
            modal.minimized = false;
            this.updateDialogsStack();
            this.updateBodyClass();
            this.updateMinimizedDialogsStack();
        }
    }

    updateMinimizedDialogsStack() {
        if (!this.$minimizedDialogsView) {
            this.$minimizedDialogsView = jQuery('<div>', {class: 'position-fixed'}).css({
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 99990,
            });
            jQuery('body').prepend(this.$minimizedDialogsView);
        }

        const buttons = [];
        let hasMinimizeButton = false;
        let hasMinimizedWindows = false;

        const modals = _.sortBy([...this.openedModals], m => m.createdAt.getTime());
        for (let modal of modals) {
            if (modal.minimized) {
                hasMinimizedWindows = true;
            }
            if (modal.minimizeButton) {
                hasMinimizeButton = true;
            }
            buttons.push(
                jQuery('<button>', {class: 'btn btm-xs btn-primary mx-1 mb-1'}).on('click', () => {
                    this.moveModalToTop(modal);
                }).append([
                    jQuery('<i>', {class: 'fal fa-window-restore mr-2'}),
                    modal.title || `Okno ${modal.cid}`
                ])
            );
        }

        this.$minimizedDialogsView.empty()
            .append(buttons)
            .toggle(hasMinimizeButton && (hasMinimizedWindows || buttons.length > 1));
    }

    updateBodyClass() {
        jQuery('body').toggleClass('modal-open', this.openedModals.filter(m => !m.minimized).length > 0);
    }

    getModalsFromPoint(x, y) {
        const modals = [];
        const elements = document.elementsFromPoint(x, y);
        let innerEl;
        for (let modal of this.openedModals) {
            if (modal.constructor.name === 'Dialog' && elements.includes(modal.$window[0])) {
                modals.push(modal);
            } else if (modal.tagName === 'PK-DIALOG') {
                for (innerEl of modal.renderRoot.elementsFromPoint(x, y)) {
                    if (innerEl.matches('.modal-content')) {
                        modals.push(modal);
                        break;
                    }
                }
            }
        }
        return modals;
    }

    opened(modal) {
        if (!this.openedModals.includes(modal)) {
            this.openedModals.push(modal);
            this.updateBodyClass();
            this.updateMinimizedDialogsStack();
        }
    }

    closed(modal) {
        if (this.openedModals.includes(modal)) {
            this.openedModals = _.without(this.openedModals, modal);
            this.updateBodyClass();
            this.updateMinimizedDialogsStack();
        }
    }

    minimized(modal) {
        modal.minimized = true;
        this.updateDialogsStack();
        this.updateBodyClass();
        this.updateMinimizedDialogsStack();
    }

    maximized(modal) {
        modal.minimized = false;
        this.updateDialogsStack();
        this.updateBodyClass();
        this.updateMinimizedDialogsStack();
    }

}

export const modalsManager = new ModalsManager();

document.addEventListener('DOMContentLoaded', () => {
    jQuery('body')
        .on('show.bs.modal', () => {
            modalsManager.updateBodyClass();
            modalsManager.updateDialogsStack();
        })
        .on('shown.bs.modal', () => {
            modalsManager.updateDialogsStack();
        })
        .on('hidden.bs.modal', () => {
            modalsManager.updateBodyClass();
            modalsManager.updateDialogsStack();
        });
});
